<sc-flex vertical fitHeight stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.select-routing-position.title"></sc-dictionary-label>
  </sc-dialog-title>




  <sc-flex-fitting-content vertical>

    <div style="height: 100%;">
      <sc-padding fitHeight>
        <sc-flex vertical fitHeight stretchContent>

          <sc-dictionary-label defaultValue="please select a position"
            dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.select-routing-position.description">
          </sc-dictionary-label>

          <sc-content-spacer [vertical]="false"></sc-content-spacer>

          <sc-flex-fitting-content vertical>
            <form [formGroup]="formGroup">
              <mat-radio-group formControlName="selectedOption">
                <sc-flex vertical stretchContent>
                  @for (option of routingPositionOptions; track option) {
                    <mat-radio-button value="{{option.routingPositionId}}"
                    >{{option.label}}</mat-radio-button>
                  }
                </sc-flex>
              </mat-radio-group>
            </form>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-padding>
    </div>

  </sc-flex-fitting-content>



  <sc-actionbar>
    <app-service-response></app-service-response>
    <sc-content-spacer grow></sc-content-spacer>
    <button mat-stroked-button mat-dialog-close>
      <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-stroked-button [disabled]="selectedOptionId == null" (click)="onSelectClicked()">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.select-routing-position.action.select"></sc-dictionary-label>
    </button>
  </sc-actionbar>


</sc-flex>
